import { render, staticRenderFns } from "./ClientDemographics.vue?vue&type=template&id=49da0263"
import script from "./ClientDemographics.vue?vue&type=script&lang=js"
export * from "./ClientDemographics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports